import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonProps,
  ChakraStyledOptions,
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import Transl from "@/src/components/translation/Transl";
import { T_KEY } from "@/src/constants/translationsKey";

import styles from "./CustomAlertDialog.module.scss";

export interface FooterButtonProps extends ButtonProps {
  text: string;
  onClick: () => void;
  isCancelButton?: boolean;
}

interface CustomAlertDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body: string;
  alertDialogFooterProps?: ChakraStyledOptions;
  footerButtons: FooterButtonProps[];
}

export default function CustomAlertDialog({
  isOpen,
  onClose,
  title,
  body,
  /* footerButton 커스터마이징을 위한 구조 */
  alertDialogFooterProps,
  footerButtons,
}: CustomAlertDialogProps) {
  const { t } = useTranslation(T_KEY);
  const cancelRef = useRef<HTMLButtonElement | null>(null);

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent mx="24px" maxW="480px">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t(title)}
          </AlertDialogHeader>

          <AlertDialogBody>
            <Transl useTranslationKey={T_KEY} i18nKey={body} />
          </AlertDialogBody>

          <AlertDialogFooter
            {...alertDialogFooterProps}
            className={styles.footer}
          >
            {footerButtons.map(
              ({ isCancelButton, text, onClick, ...rest }, index) => (
                <Button
                  key={index}
                  ref={isCancelButton ? cancelRef : undefined}
                  onClick={onClick}
                  {...rest}
                >
                  {t(text)}
                </Button>
              )
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
